(ns frontend.ui.component.lp-portal.report.body.real-estate.fund.koke.controller.overview
  (:require
   [frontend.ui.page.lp-portal.report.util :as util]
   [frontend.ui.component.lp-portal.donut-chart.view :as donut-chart]
   [frontend.ui.component.lp-portal.report.controller :as report-ctl]
   [frontend.ui.component.lp-portal.report.overview.big-figures.controller :as big-figures]
   [frontend.ui.component.chart.utils :as chart-utils]))

(defn- overview-figures
  [summary-of-returns]
  [[(util/->multiple (:gross-multiple summary-of-returns)) "Gross Multiple"]
   [(util/->multiple (:return-to-investors-multiple-tvpi summary-of-returns)) "Net Multiple"]
   [(util/->percent-1-decimal (:gross-irr summary-of-returns)) "Gross IRR"]
   [(util/->percent-1-decimal (:net-irr summary-of-returns)) "Net IRR"]])

(defn- lettable-area-by-sector
  [{:keys [labels m2]}]
  (map vector labels m2))

(defn- leased-area-by-tenant
  [{:keys [labels m2]}]
  (map vector labels m2))

(defn overview
  [{:keys [dynamic-path dynamic-data report-data map-topo] :as props}]
  {:overview-figures (report-ctl/with-footnote
                      props
                      :overview-figures-footnotes
                      (big-figures/koke-figures report-data))
   :recent-development-text (report-ctl/rich-content props :recent-development-text)
   :highlights (report-ctl/with-footnote
                props
                :highlight-footnotes
                (get-in report-data
                        [:fund-figures]))
   :lettable-area-by-sector (report-ctl/with-footnote
                             props
                             :lettable-area-by-sector-footnotes
                             (donut-chart/donut-chart-config
                              (lettable-area-by-sector
                               (get-in report-data
                                       [:chart-data-lettable-and-lease :lettable-area-by-sector]))
                              {:data-label-formatter chart-utils/pie-m2-and-%-formatter}))
   :leased-area-by-tenant (report-ctl/with-footnote
                           props
                           :leased-area-by-tenant-footnotes
                           (donut-chart/donut-chart-config
                            (leased-area-by-tenant
                             (get-in report-data
                                     [:chart-data-lettable-and-lease :leased-area-by-tenant]))
                            {:data-label-formatter chart-utils/pie-m2-and-%-formatter}))})
